import { render, staticRenderFns } from "./index-hoc.vue?vue&type=template&id=72a83140&"
import script from "./index-hoc.vue?vue&type=script&lang=js&"
export * from "./index-hoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports